export default __webpack_public_path__ + "static/media/ico-seta.301f054e.svg";